/**
 * Rename simulation round units
 */

export default {
  applyToVersions: "<=2.2.4",
  type: "before",
  name: "rename simulation round units",
  migrate(data) {
    if (!data?.project) return data;
    const project = data.project;

    // transfer the old property names to the new system:
    if (project.roundName) {
      project.simulationRoundName = project.roundName;
      delete project.roundName;
    }
    if (project.roundUnit != null) {
      project.simulationRoundUnit = project.roundUnit;
      delete project.roundUnit;
    }
    if (project.roundLength != null) {
      project.simulationRoundLength = project.roundLength;
      delete project.roundLength;
    }
    if (project.roundIsCustom != null) {
      project.simulationRoundCustomized = project.roundIsCustom;
      delete project.roundIsCustom;
    }
    if (project.simulationLengthType != null) {
      project.simulationDurationType = project.simulationLengthType;
      delete project.simulationLengthType;
    }
    if (project.defaultSimulationLength != null) {
      project.simulationRoundAmount = project.defaultSimulationLength;
      delete project.defaultSimulationLength;
    }

    return data;
  }
};
